import axios from 'axios'
import { ElMessage } from 'element-plus'

const baseURL = process.env.VUE_APP_API_BASE || ''

//调试入口，400报错，'false'关闭
const __HTTP_DEBUG__ = false

const isHttpDebug = () => __HTTP_DEBUG__

const http = axios.create({
  baseURL,
  timeout: 15000
})

// 避免重复弹窗与重定向
let hasShown401Message = false
let redirectingToLogin = false

http.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem('Authorization') || localStorage.getItem('token') || ''
      if (token) config.headers = { ...(config.headers || {}), Authorization: token }
      // 自动设置 JSON Content-Type，FormData 交给浏览器处理
      const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData
      if (!isFormData) {
        config.headers = { ...(config.headers || {}), 'Content-Type': config.headers?.['Content-Type'] || 'application/json' }
      }
      if (isHttpDebug()) {
        try {
          window.__lastHttpRequest = {
            url: config.url,
            method: (config.method || 'get').toUpperCase(),
            headers: { ...(config.headers || {}) },
            data: config.data
          }
        } catch { void 0 }
        console.log(`%c🌐 API请求 ${config.method?.toUpperCase()} ${config.url}`, 'color: #4CAF50; font-weight: bold')
        if (config.params) console.log('📤 查询参数:', config.params)
        if (config.data) console.log('📤 请求体:', config.data)
      }

    } catch {
      // ignore token read errors
      void 0
    }
    return config
  },
  (error) => Promise.reject(error)
)

http.interceptors.response.use(
  (response) => {
    if (isHttpDebug()) {
      console.log(`%c✅ API响应 ${response.config.method?.toUpperCase()} ${response.config.url}`, 'color: #2196F3; font-weight: bold')
      console.log('📥 响应数据:', response.data)
    }
    return response
  },
  (error) => {
    const status = error?.response?.status
    const url = error?.config?.url || ''

    // 静默处理已知未实现的API端点（开发中）
    const silentEndpoints = [
      '/report-periods-time/all',
      '/report-periods-time/enabled',
      '/report-periods-time/insert',
      '/report-periods-time/update',
      '/report-periods-time/delete',
      '/api/permission/roles',
      '/api/permission/modules',
      '/api/permission/role'
    ]

    const isSilentEndpoint = silentEndpoints.some(endpoint => url.includes(endpoint))
    const shouldSilence = status === 404 && isSilentEndpoint

    // 统一处理 401：清除令牌并跳转登录页
    if (status === 401) {
      try {
        localStorage.removeItem('Authorization')
        localStorage.removeItem('token')
      } catch { void 0 }
      if (!hasShown401Message && !error.config?.skipErrorMessage) {
        hasShown401Message = true
        try { ElMessage.error('登录已过期，请重新登录') } catch { void 0 }
      }
      if (!redirectingToLogin) {
        redirectingToLogin = true
        // 为避免模块循环依赖，使用 location 跳转
        setTimeout(() => {
          try {
            window.location.href = '/login'
          } catch {
            window.location.reload()
          }
        }, 0)
      }
    } else if (status === 403) {
      // 无权限访问：给出明确提示，不做跳转
      if (!error.config?.skipErrorMessage) {
        try { ElMessage.error('无权限访问，请联系管理员或切换账号') } catch { void 0 }
      }
    } else if (status >= 500 && status < 600) {
      // 服务端错误：统一提示稍后重试
      if (!error.config?.skipErrorMessage) {
        try { ElMessage.error('服务器异常，请稍后重试') } catch { void 0 }
      }
    } else if (!status && !shouldSilence) {
      // 无响应或被取消：给出网络异常提示（除非是静默端点）
      if (!error.config?.skipErrorMessage) {
        try { ElMessage.error('网络异常或请求被取消') } catch { void 0 }
      }
    }

    // 其他错误按原逻辑封装
    const message = error?.response?.data?.message || error?.response?.data?.msg || error?.message || '请求失败'
    const err = new Error(message)
    err.status = status
    err.raw = error
    return Promise.reject(err)
  }
)

export default http
